import React from "react";

const Heading = () => (
  <header className="App-header">
    <img
      className="logo-image"
      alt={"Logo"}
      src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Mercure_Hotels_Logo_2013.svg/1200px-Mercure_Hotels_Logo_2013.svg.png"
    />
    <img
      className="logo-image"
      alt={"Logo"}
      src="https://codeyourfuture.io/wp-content/uploads/2019/03/cyf_brand.png"
    />
  </header>
);

export default Heading;
